"use client";

import { useContext } from "react";

import {
  TemplatesProviderContext,
  type TemplatesProviderState,
} from "../contexts";

export const useTemplates = (): TemplatesProviderState => {
  const context = useContext(TemplatesProviderContext);
  if (!context) {
    throw new Error("useTemplates must be used within a TemplatesController");
  }

  return context;
};

export const useMaybeTemplates = (): TemplatesProviderState | undefined => {
  const context = useContext(TemplatesProviderContext);

  return context;
};
